@if (displayBackToWellbeing) {
  <button appButton="small" class="carbon_back_button" (click)="back(true)">
    <i class="ico ico-arrow-left"></i
    ><span i18n="@@backToWellbeingResults">Back to Wellbeing Results</span>
  </button>
}
@if (displayBackToPrevious) {
  <button appButton="small" class="carbon_back_button" (click)="back()">
    <i class="ico ico-arrow-left"></i
    ><span i18n="@@backToPreviousResults">Back to Previous Results</span>
  </button>
}
@if (policies.length) {
  <div class="background-container-background carbon-container">
    <h2 class="visuallyhidden">Carbon Allowance</h2>
    <div class="flex-row-container spaced">
      <span class="co2_margin" i18n="@@CO2AllowanceRemaining"
        >CO<sub>2</sub> Allowance Remaining</span
      >
      @if (policies[0].carbonPolicySource === CarbonPolicySource.User) {
        <span i18n="@@CO2ForSelectedTravellers"> For Selected Travellers</span>
      }
      <span>
        <a
          href="javascript:void(0)"
          (click)="hidePolicy()"
          tabindex="0"
          (keydown.enter)="hidePolicy()"
          (keydown.space)="hidePolicy()"
          class="carbon-toggle"
        >
          <span>
            @if (!hideAllowance) {
              <span i18n="@@searchToggleState_hide">Hide</span>
            }
            @if (hideAllowance) {
              <span i18n="@@searchToggleState_show">Show</span>
            }
            <span i18n="@@carbonAllowanceDisplayButton"> Carbon Allowance</span>
          </span>
          <i [ngClass]="!hideAllowance ? 'ico-tri-up' : 'ico-tri-down'" aria-hidden="true"></i> </a
      ></span>
    </div>
    @if (!hideAllowance) {
      @for (policy of policies; track policy; let first = $first) {
        <app-carbon-allowance
          [policy]="policy"
          [first]="first"
          [co2PerItem]="co2PerItem"
          [currentId]="currentId"
          [basket]="basket"
        ></app-carbon-allowance>
      }
    }
  </div>
}
